<template>
  <div>
    <banner :bgSrc="bannerBg" :showDownload="false"></banner>
    <div class="download">
      <div class="mainContent">
        <div class="moduleTitle">软件安装包下载</div>
        <div class="downArea flex justify-center">
          <div
            v-for="(item, idx) in downloadList"
            :key="idx"
            @mouseenter="
              () => {
                curIdx = idx;
              }
            "
            @mouseleave="
              () => {
                curIdx = null;
              }
            "
            :style="{
              backgroundImage:
                curIdx === idx
                  ? 'url(' + hoverBg + ')'
                  : 'url(' + defaultBg + ')',
              color: curIdx === idx ? '#fff' : '#17406F',
              width: curIdx === idx ? '247px' : ' 203px',
              flexGrow: 0
            }"
          >
            <div
              class="appTitle"
              :style="{
                color: curIdx === idx ? '#fff' : '#17406F',
              }"
            >
              {{ item.label }}
            </div>
            <div
              class="splitList"
              :style="{
                backgroundColor: curIdx === idx ? '#fff' : '#17406F',
              }"
            ></div>
            <div class="version">{{ item.version }}</div>
            <div
              class="downloadBtn"
              @click="download(item.val)"
            >
              点击下载
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import banner from "@/components/banner.vue";
import { ref, onMounted } from "vue";
import bannerBg from "@/assets/imgs/price/priceBg.png";
import hoverBg from "@/assets/imgs/download/hoverBg.png";
import defaultBg from "@/assets/imgs/download/defaultBg.png";
import dataService from "@/service/data"
// import dataService from "@/service/data";
const curIdx = ref(null);
const downloadList = ref([]);
// const downloadList = [
//   {
//     label: "易回复安装包",
//     version: "最新稳定版",
//     val: "https://wwpd.lanzouw.com/iYpnJ1ki5a8d",
//   },
// ];
const download = (fileUrl) => {
  window.open(fileUrl, "_blank");
};
onMounted(async () => {
  let data = await dataService.get("SOFT_REPLAY_DOWNLOAD_CONFIG");
  let value = JSON.parse(data.valued);
  downloadList.value = value[0].child;
});
</script>
<style scoped>
.download {
  background: #fff;
}
.mainContent {
  padding: 5.625rem 0 8.125rem;
}
.moduleTitle {
  margin-bottom: 4.5rem;
}
.downArea > div {
  overflow: hidden;
  border-radius: 1rem;
  padding: 2rem 1.5rem;
  flex-grow: 1;
  height: 260px;
  margin-right: 1.5rem;
  position: relative;
  background-repeat: no-repeat;
  transition: all 0.2s linear;
}
.downArea > div:last-child {
  margin-right: 0;
}
.appTitle {
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.splitList {
  margin: 20px 0 24px;
  height: 2px;
  width: 32px;
}
.version {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.downloadBtn {
  position: absolute;
  display: inline-block;
  color: #3581ff;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border-radius: 28px;
  background: #fff;
  padding: 10px 28px;
  bottom: 2rem;
  left: 2rem;
  cursor: pointer;
}
@media (min-width: 768px) {
}
</style>
